import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"
import { login } from "../../services/auth"
import $ from "jquery"
import MaskedInput from 'react-maskedinput'
import securityimg from "../../assets/img/security.png"
import blindadosite from "../../assets/img/blindadosite.png"

import Logo from "../../assets/img/logo4.jpg"
import Modal from "../content/modal"


class InscreverUser extends Component {


  constructor(props){
    super(props);
    this.state = {
      error:null,
      email:null,
      nome:null,
      sobrenome:null,
      telefone1: null,
      telefone2:null,
      cpf:null,
      nomecompleto:null,
      cursos:[],
      idcurso:null,
      countredirect:null,
      btn:'Concluir Inscrição',
      btn_disable:false,
      categorias:[]
     }
  }
  
  _onChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

   async ischeck(dado){
    const response2 = await api.post("/isuser", { dadouser:dado});

        if(response2.data.success){

          if(this.state.countredirect>=3){
            this.props.history.push("/user/inscreva/login/"+dado);
            return true;
          }
        

        }else{
          return false;
        }

   }

   shouldComponentUpdate(nextProps, nextState)
  {

    if(nextState.indicacao!==this.state.indicacao){
      console.log(nextState.indicacao)
    }
    
    if(nextState.email!==this.state.email){
      nextState.countredirect=nextState.countredirect+1;
     this.ischeck(nextState.email);

    }else if(nextState.cpf!==this.state.cpf){
      nextState.countredirect=nextState.countredirect+1;
      this.ischeck(nextState.cpf)

    }

    
    return true;

  }

  handleSignup = async e => {
    e.preventDefault();
    this.setState({ btn: "Aguarde", btn_disable:true });

    
    const { email, password, telefone1,telefone2, cpf, nome, sobrenome, idcurso,indicacao } = this.state;

    
      if (!email || !password || !telefone1 || !cpf || !nome || !sobrenome || !idcurso) {
          this.setState({ error: "Preencha os dados para continuar!" });
          
      } else {
      
        try{
      const response = await api.post("/reg", {idcurso,isgraduation:0, email, password, nome, sobrenome, telefone1, telefone2, cpf, indicacao});

          login(response.data.success.token);

          const response2 = await api.post("/user/curso/matricular", { indicacao,idcurso});



          this.props.history.push("/user/cursos");



        }catch(ex){
          this.setState({ error: "Ocorreu um erro, verifique os campos e tente novamente" });
          this.setState({ btn: "Concluir Inscrição", btn_disable:false });
        }
      
     

    }

  }


  async componentDidMount(){
    const response = await api.post("/cursos", {idunidade:localStorage.getItem('idunidade')});

     this.setState({ cursos: response.data,
      idcurso:localStorage.getItem("idcurso")});


    const response1 = await api.post("/categorias", {idunidade:localStorage.getItem('idunidade')});
      this.setState({ 
        categorias: response1.data})


      if(this.props.match.params.indicacao){
        this.setState({ 
          indicacao:this.props.match.params.indicacao
        });

        localStorage.setItem("indicacao", this.props.match.params.indicacao);

      }else if(!this.props.match.params.indicacao && localStorage.getItem("indicacao")){
        this.setState({ 
          indicacao:localStorage.getItem("indicacao")
        });

      }


      
  }



  render() {

   
    return (
      <React.Fragment>
             <Modal />
<div class="container col-lg-4">

<form class="text-center border border-light p-5" autocomplete="off" onSubmit={this.handleSignup}>

      <h3>Faculdade Olga Mettig</h3>
    <p class="h5 mb-4">Inscreva-se</p>

    {this.state.error && <h6><p>{this.state.error}</p></h6>}
    <div class="form-row mb-4">
   

        

        <div class="col">
       
            <input type="text" required  onChange={e => this.setState({ nome: e.target.value })} class="form-control" placeholder="Nome" />
        </div>
        <div class="col">
            
            <input type="text" required onChange={e => this.setState({ sobrenome: e.target.value  })} class="form-control" placeholder="Sobrenome" />
        </div>
    </div>
   
      
    <input  required class="form-control mb-4"  onChange={e => this.setState({ cpf: e.target.value  })} placeholder="Seu CPF" aria-describedby="defaultRegisterFormPhoneHelpBlock" />



    <input type="email" defaultValue="" required onChange={e => this.setState({ email: e.target.value  })}  class="form-control mb-4" placeholder="Seu E-mail" />


    <input type="password" required onChange={e => this.setState({ password: e.target.value  })} class="form-control" placeholder="Crie uma senha" aria-describedby="defaultRegisterFormPasswordHelpBlock" />
    <small id="defaultRegisterFormPasswordHelpBlock" class="form-text text-muted mb-4">
       
    </small>

    <input class="form-control mb-4" name="telefone1" onChange={this._onChange} placeholder="Telefone" aria-describedby="defaultRegisterFormPhoneHelpBlock" />

    <label>Escolha seu Curso</label>
    <select class="form-control mb-4 " defaultValue={localStorage.getItem("idcurso")} required onChange={e => this.setState({ idcurso: e.target.value })}>
      <option value="">Selecione seu curso</option>
      
      {this.state.categorias.map(el => (
        <optgroup label={el.nome}>

        {el.pos_cursos.map(elc => (

elc.isgraduation=='0' &&
        elc.status=='1' &&

          <option value={elc.id} selected={el.id==localStorage.getItem("idcurso")}>{elc.nome}</option>
        ))}
       </optgroup>
      ))
      }
    </select>  

    <label>Código de Indicação? </label>
    <input type="text" defaultValue={this.state.indicacao} onChange={e => this.setState({ indicacao: e.target.value  })} class="form-control mb-4" placeholder="Campo não obrigatório" aria-describedby="defaultRegisterFormPhoneHelpBlock" />

   
 
    <button class="btn btn-success my-4 btn-block" type="submit" disabled={this.state.btn_disable}>{this.state.btn}</button>

  
   
    

</form>
<center>
<img src={securityimg} class="img-thumbnail" width="170" height="120" />
<img src={blindadosite} class="img-thumbnail" width="170" height="120" />
</center>
<br></br>
</div>

      </React.Fragment>
       
    );
  }
}

export default withRouter(InscreverUser);


// WEBPACK FOOTER //
// ./src/pages/User/inscreva.js